/* global __CLIENT__*/
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import moment from 'moment';

import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import { BaselineActions } from '../../../actions/baseline';
import { ModalActions } from '../../../actions/modal';
import BaselineItem from './BaselineItem';

import {
  currentProjectIdSelector,
} from '../../../reducers/projects';
import {
  baseLinesSelector,
} from '../../../reducers/baselines';
// import '../../styles/ProjectUsers.css';

const BaseLineSelector = immutableCreatorSelector(
  [
    currentProjectIdSelector,
    baseLinesSelector,
  ],
  (
    currentProjectId,
    baseLines
  ) => ({
    currentProjectId,
    baseLines,
  })
);

@connect(BaseLineSelector)
export default class Baselines extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    currentProjectId: PropTypes.string,
    baseLines: PropTypes.instanceOf(Map),
  };

  componentDidMount = () => {
    const { currentProjectId, dispatch } = this.props;
    if (currentProjectId) {
      dispatch(BaselineActions.getProjectBaselinesList(currentProjectId));
    }
  }

  confirmDelete = (baselineId, name) => {
    const { dispatch } = this.props;
    dispatch(ModalActions.toggleModal({
      name: 'DeleteConfirmationModal',
      options: {
        deleteType: 'baseline',
        handleDelete: this.handleDelete.bind(null, baselineId),
        name,
      },
    }));
  }

  handleDelete = (baselineId) => {
    this.props.dispatch(
      BaselineActions.deleteBaseLine(this.props.currentProjectId, baselineId)
    );
  }

  handleClickCreateBaseline = (e) => {
    e.preventDefault();
    this.props.dispatch(ModalActions.toggleModal({
      name: 'CreateBaseLineModal',
    }));
  }

  renderBaseLineList = () => {
    const {
       baseLines,
     } = this.props;

    return baseLines.valueSeq().sortBy(o => - parseInt(o.get('id'), 10)).map(v =>
      <BaselineItem
        key={v.get('id')}
        id={v.get('id')}
        name={v.get('name')}
        createdAt={moment(v.get('created_at'))}
        onDelete={this.confirmDelete}
      />
    );
  }


  render() {
    return (
      <span>
        <h2 className="mt-2">Baselines</h2>
        <button
          className="btn btn-primary btn-sm"
          type="button"
          onClick={this.handleClickCreateBaseline}
          style={{ marginBottom: 5 }}
        >
          <i className="fa fa-plus"></i> Create New Baseline
        </button>
        <div className="list-group">
          {this.renderBaseLineList()}
        </div>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/Baselines/Baselines.js